import React, { useState, useEffect } from "react";
import clsx from "clsx";
import { connect } from "react-redux";
import { Box, Paper, makeStyles } from "@material-ui/core";
import Project from "../project/Project";
import Import from "../import/Import";
import { Route, useRouteMatch } from "react-router-dom";
import ExtendablePanel from "../extendablePanel/ExtendablePanel";
import Fade from "@material-ui/core/Fade";
import LoadingCircle from "../common/LoadingCircle";
import DragContext from "../optimized/DragContext";
import { remCalc } from "../../utils/helpers";
import {
  setUploadStopsOpen,
  setUploadStopsSimpleOpen
} from "../../store/actions/account";
import { paths } from "../data/constants";

const useStyles = makeStyles(theme => ({
  root: {
    height: "100vh",
    width: remCalc(448),
    display: "inline-flex",
    position: "relative",
    zIndex: 1,
    /*
    [theme.breakpoints.down("md")]: {
      width: "29rem"
    },*/

    "& .MuiIconButton-colorPrimary.Mui-checked svg": {
      color: theme.palette.primary.main
    },

    "& .tooltipOpener:hover": {
      color: theme.variables.rootColor
    }
  },
  paper: {
    height: "100%",
    width: "100%",
    display: "flex",
    flexDirection: "column",
    boxSizing: "border-box",
    borderRadius: 0,
    transform: "translateX(0)",
    opacity: 1,
    visibility: "visible",
    boxShadow: "0 3px 6px rgba(0, 0, 0, 0.15)",
    transition:
      "transform .2s ease-in-out," +
      "opacity .2s ease-in-out," +
      "visibility .2s ease-in-out;"
  },
  paperUpload: {
    position: "absolute",
    zIndex: 20
  },
  drawerClosed: {
    transform: "translateX(-100%)"
  }
}));

function Drawer({
  drawerOpen,
  loadingDrawer,
  plan,
  uploadStopsOpen,
  uploadStopsSimpleOpen,
  setUploadStopsOpen,
  setUploadStopsSimpleOpen,
  isBreak,
  loadingProject,
  loadingProjectInitial
}) {
  const classes = useStyles();

  const [expanded, setExpanded] = useState(isBreak ? [2] : [0, 1]);

  const match_upload = useRouteMatch("/:projectId/upload-stops");
  const match_upload_simple = useRouteMatch("/:projectId/upload-stops-simple");
  const match_projectId = useRouteMatch("/:projectId");

  useEffect(() => {
    if (match_upload && !uploadStopsOpen) {
      setUploadStopsOpen(true);
    } else if (
      match_projectId &&
      !match_upload &&
      !paths.includes(match_projectId.params.projectId) &&
      uploadStopsOpen
    ) {
      setUploadStopsOpen(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [match_upload, match_projectId, uploadStopsOpen]);

  useEffect(() => {
    if (match_upload_simple && !uploadStopsSimpleOpen) {
      setUploadStopsSimpleOpen(true);
    } else if (
      match_projectId &&
      !match_upload_simple &&
      !paths.includes(match_projectId.params.projectId) &&
      uploadStopsSimpleOpen
    ) {
      setUploadStopsSimpleOpen(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [match_upload_simple, match_projectId, uploadStopsSimpleOpen]);

  return (
    <Box className={classes.root} id="project_drawer">
      {/* Loading */}
      <Fade in={loadingDrawer} mountOnEnter unmountOnExit>
        <LoadingCircle />
      </Fade>

      {/* Import*/}
      {plan.ft_spreadsheet_upload && uploadStopsSimpleOpen && (
        <Route
          path="/:projectId"
          render={() => (
            <Box
              component={Paper}
              className={clsx(classes.paper, classes.paperUpload, {
                [classes.drawerClosed]: !drawerOpen
              })}
            >
              <Import />
            </Box>
          )}
        />
      )}

      {/* Project */}
      <Route
        path="/"
        render={() => (
          <Box width="100%">
            <DragContext>
              {/* Project loading */}
              <Fade
                in={loadingProject && !loadingProjectInitial}
                mountOnEnter
                unmountOnExit
              >
                <Box>
                  <LoadingCircle blur drawerOpen={drawerOpen} />
                </Box>
              </Fade>
              <ExtendablePanel expanded={expanded} setExpanded={setExpanded} />

              {/* Drawer Body */}
              <Box
                position="relative"
                component={Paper}
                className={clsx(classes.paper, {
                  [classes.drawerClosed]: !drawerOpen
                })}
              >
                <Project setExpanded={setExpanded} />
              </Box>
            </DragContext>
          </Box>
        )}
      />
    </Box>
  );
}

function mapStateToProps(state) {
  return {
    drawerOpen: state.common.drawerOpen,
    loadingDrawer: state.loading.routesList,
    plan:
      (state.auth.userData.organisationSite &&
        state.auth.userData.organisationSite.organisation.plan) ||
      {},
    uploadStopsOpen: state.common.uploadStopsOpen,
    uploadStopsSimpleOpen: state.common.uploadStopsSimpleOpen,
    isBreak: state.extendable.props.isBreak,
    loadingProject: state.loading.project,
    determinateLoading: state.loading.determinateLoading,
    loadingProjectInitial: state.loading.projectInitial
  };
}

export default connect(mapStateToProps, {
  setUploadStopsOpen,
  setUploadStopsSimpleOpen
})(Drawer);
